<div class="container mt-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <h2>Connexion</h2>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        @if (error) {
          <div class="alert alert-danger">L'utilisateur n'existe pas, où le mot de passe n'est pas le bon.</div>
        }
        <div class="form-group mb-3">
          <label for="email">Adresse e-mail</label>
          <input type="email" id="email" class="form-control" formControlName="email" placeholder="Entrez votre e-mail" />
          @if (loginForm.get('email')?.invalid && loginForm.get('email')?.touched) {
            <div class="text-danger">
              L'adresse e-mail est requise et doit être valide.
            </div>
          }
        </div>

        <div class="form-group mb-3">
          <label for="password">Mot de passe</label>
          <input type="password" id="password" class="form-control" formControlName="password" placeholder="Entrez votre mot de passe" />
          @if (loginForm.get('password')?.invalid && loginForm.get('password')?.touched) {
            <div class="text-danger">
              Le mot de passe est requis (minimum 6 caractères).
            </div>
          }
        </div>

        <button type="submit" class="btn btn-primary" [disabled]="loginForm.invalid">Connexion</button>

        <div class="mt-3">
          <a routerLink="/forgot-password">Mot de passe oublié ?</a>
        </div>
      </form>
    </div>
  </div>
</div>
